<form name="form" [formGroup]="form" (ngSubmit)="savePaymentMethods()">
    <div class="row">
        <div class="col-12 mb-4">
            <div class="bloc-title mb-3">Billing address</div>
            <div class="bg-gray-200 p-3 br-15">
                <div class="row">
                    <div class="col-6 mb-4">
                        <mat-form-field class="form-group dark-input">
                            <input
                                matInput
                                formControlName="firstName"
                                type="text"
                                placeholder="First Name"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-6 mb-4">
                        <mat-form-field class="form-group dark-input">
                            <input
                                matInput
                                formControlName="lastName"
                                type="text"
                                placeholder="Last Name"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-6 mb-4">
                        <mat-form-field class="form-group dark-input">
                            <input matInput formControlName="city" type="text" placeholder="City" />
                        </mat-form-field>
                    </div>
                    <div class="col-6 mb-4">
                        <mat-form-field class="form-group dark-input">
                            <mat-label>Country</mat-label>
                            <mat-select
                                formControlName="country"
                                panelClass="select-panel-down"
                                [disableOptionCentering]="true"
                            >
                                <mat-option
                                    *ngFor="let country of countries"
                                    [value]="country.label"
                                    class="text-capitalize"
                                >
                                    {{ country.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6 mb-4">
                        <mat-form-field class="form-group dark-input">
                            <input
                                matInput
                                formControlName="street"
                                type="text"
                                placeholder="Street"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-6 mb-4">
                        <mat-form-field class="form-group dark-input">
                            <input
                                matInput
                                formControlName="building"
                                type="text"
                                placeholder="Building"
                            />
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field class="form-group dark-input">
                            <input
                                matInput
                                formControlName="postalCode"
                                type="text"
                                placeholder="Postal Code"
                            />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100">
        <button class="btn btn-lg btn-gray-500 float-right" [disabled]="!form.valid">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            save
        </button>
        <div class="clearfix"></div>
    </div>
</form>
